type WidgetEmbedOptions = {
  token: string
  /** Inline (demo) mode: CSS selector of the container. */
  inlineContainer?: string
  /** WordPress: WP Rocket's Minify skips such a tag instead of re-hosting a frozen copy of the loader; Combine ignores it. */
  noMinify?: boolean
}

export function buildWidgetEmbedSnippet(
  host: string,
  { token, inlineContainer, noMinify = false }: WidgetEmbedOptions,
): string {
  const inlineAttrs = inlineContainer === undefined
    ? ""
    : ` data-mode="inline" data-container="${inlineContainer}"`
  const noMinifyAttr = noMinify ? ' data-no-minify="1"' : ""
  return `<script src="${host}/widget-loader.js" data-token="${token}"${inlineAttrs}${noMinifyAttr} async></script>`
}
